<template>
  <div class="load-dot">
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
  </div>
</template>

<script>
  export default {}
</script>

<style lang="stylus">
  @keyframes loadingLine {
    0% {
      transform: translate(0, -7px)
    }
    50% {
      transform: translate(0, 7px)
    }
    100% {
      transform: translate(0, -7px)
    }
  }

  .load-dot .dot:nth-last-child(1) {
    animation: loadingLine .6s -.1s linear infinite;
  }

  .load-dot .dot:nth-last-child(2) {
    animation: loadingLine .6s -.2s linear infinite;
  }

  .load-dot .dot:nth-last-child(3) {
    animation: loadingLine .6s -.3s linear infinite;
  }

  .load-dot {
    padding  .5em .75em
  }

  .load-dot .dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 8px;
    background-color: #D3CFFE;
  }
</style>